import React from 'react';

const SobreNosotros = () => {
  return (
    <div className="w-full min-h-screen bg-gray-50 flex justify-center py-10">
      <div className="w-11/12 lg:w-3/4 bg-white p-8 rounded-lg space-y-8 border-2 border-GrisOscuro">
        <h1 className="text-4xl font-bold text-gray-800 text-center">Sobre Nosotros</h1>

        <section>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">¿Quiénes Somos?</h2>
          <p className="text-gray-600">
            En <span className="font-semibold text-green-700">AgroH</span>, somos una empresa dedicada a ofrecer soluciones tecnológicas avanzadas para el sector agrícola. Nos especializamos en optimizar procesos clave como la pulverización y la siembra, con un enfoque claro en el ahorro de agroquímicos y la mejora de la eficiencia. Nuestro objetivo es ayudar a los agricultores a obtener mejores resultados, reducir costos y contribuir a la sostenibilidad ambiental.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">Compromiso con la Innovación</h2>
          <p className="text-gray-600">
            Desde nuestra creación, nos hemos comprometido a transformar la producción agrícola mediante el uso de tecnologías de precisión. Nuestras soluciones están diseñadas para mejorar la gestión de los recursos, reducir el uso de insumos y promover prácticas agrícolas más sostenibles. Esto resulta en una mayor rentabilidad y un menor impacto ambiental.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">Nuestra Visión</h2>
          <p className="text-gray-600">
            Nuestra visión es hacer que las tecnologías de precisión sean una práctica común en la agricultura de todo el país, no solo una tendencia. Queremos ser reconocidos como un referente en el sector: una empresa familiar que perdura en el tiempo, comprometida con la innovación y el cuidado del medio ambiente.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">Nuestro Equipo</h2>
          <p className="text-gray-600">
            Contamos con un equipo profesional altamente capacitado que trabaja de manera colaborativa para brindar las mejores soluciones tecnológicas adaptadas a las necesidades de cada cliente. Valoramos la confianza y la relación a largo plazo con nuestros socios y clientes, basada en la integridad, la responsabilidad y el compromiso con la calidad.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">Nuestro Compromiso con la Sostenibilidad</h2>
          <p className="text-gray-600">
            Estamos profundamente comprometidos con la sostenibilidad. Sabemos que el futuro de la agricultura depende de adoptar tecnologías que optimicen los recursos naturales y minimicen su impacto en el medio ambiente. Por eso, cada una de nuestras soluciones busca no solo mejorar los rendimientos, sino también promover una agricultura más ecológica y responsable.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">Innovación y Clientes</h2>
          <p className="text-gray-600">
            La innovación es la base de nuestro trabajo. Siempre estamos en la búsqueda de nuevas tecnologías que nos permitan seguir mejorando y ofrecer productos que se adapten a las necesidades cambiantes del sector agrícola. Cada agricultor, sin importar el tamaño de su explotación, es para nosotros un socio valioso. Nos dedicamos a conocer sus desafíos y a ofrecerles soluciones personalizadas que optimicen su trabajo y aumenten sus ganancias.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">En Resumen</h2>
          <p className="text-gray-600">
            En <span className="font-semibold text-green-700">AgroH</span>, no solo vendemos tecnología. Trabajamos para hacer la agricultura más inteligente, eficiente y sostenible. Queremos ser parte de un futuro agrícola donde la innovación y la sostenibilidad sean clave para mejorar los resultados y proteger el medio ambiente.
          </p>
        </section>
      </div>
    </div>
  );
};

export default SobreNosotros;
